<template>
    <dg-field-container :label_span="label_span" :field_span="field_span" :field_mark="field_mark"
         :field_validate_message="validateMessage">
        <template v-slot:label>
          <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
        </template>
        <template v-slot:field>
            <div style="padding: 5px;">
              <div v-if="editable">
                <el-checkbox v-if="show_select_all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$ml.get('select_all')}}</el-checkbox>
                <el-checkbox-group v-model="field_value" @change="handleCheckedValuesChange">
                    <el-checkbox v-for="option in options" :label="option.value" :key="option.value" :disabled="disabled" :style="checkboxStyle">
                        {{ (translateLabels)?$ml.get(option.label): option.label }}
                        <a v-if="option.link" :href="option.link" target="_blank"> - {{$ml.get(option.link_label)}}</a>
                    </el-checkbox>
                </el-checkbox-group>
                <slot name="field_note"></slot>
              </div>
              <div v-else>
                <dg-label-field :label="field_value" :translate="false"></dg-label-field>
              </div>
            </div>
        </template>
    </dg-field-container>
</template>

<script>
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
  translateLabels: {
      default: false
   },
   checkboxStyle: {
      required: false,
      default: ''
    },
    options: {
      required: true,
      type: Array
    },
    show_select_all: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      field_value: [],
      isIndeterminate: false,
      checkAll: false,
      binding: 'checkbox'
    }
  },
  methods: {
    handleCheckAllChange (val) {
      this.field_value = val ? this.getOptionsValues() : [];
      this.isIndeterminate = false;
    },
    getOptionsValues () {
      let o = this.options;
      let v = [];
      for (let x in o) {
        v.push(o[x].value)
      }
      return v;
    },
    handleCheckedValuesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.options.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length;
      if (this.field_value.length === 0 && this.options.length === 1) {
        this.field_value = [0]
      }
      this.updateValue();
    }
  }
}
</script>
